import { render, staticRenderFns } from "./StaticAssessmentEdit.vue?vue&type=template&id=1b5c213c&"
import script from "./StaticAssessmentEdit.vue?vue&type=script&lang=js&"
export * from "./StaticAssessmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./StaticAssessmentEdit.vue?vue&type=style&index=0&id=1b5c213c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports